import { shallowMount } from "@vue/test-utils";
import VeridasAnalytics from "@/components/core/custom/VeridasAnalytics.vue";

describe("VeridasAnalytics.vue", () => {
  let wrapper;

  beforeAll(() => {
    Object.defineProperty(window, "matchMedia", {
      writable: true,
      value: jest.fn().mockImplementation(query => ({
        matches: false,
        media: query,
        onchange: null,
        addListener: jest.fn(),
        removeListener: jest.fn(),
        addEventListener: jest.fn(),
        removeEventListener: jest.fn(),
        dispatchEvent: jest.fn()
      }))
    });
  });

  beforeEach(() => {
    wrapper = shallowMount(VeridasAnalytics, {
      mocks: {
        $log: {
          info: jest.fn(),
          error: jest.fn(),
          debug: jest.fn()
        }
      }
    });
    window.digitalData = {};
  });

  afterEach(() => {
    wrapper.destroy();
  });

  it("renders empty component", () => {
    expect(wrapper.html()).toBe("");
  });

  it("adds message event listener on shallowMount", () => {
    const addEventListenerSpy = jest.spyOn(window, "addEventListener");
    shallowMount(VeridasAnalytics);
    expect(addEventListenerSpy).toHaveBeenCalledWith(
      "message",
      expect.any(Function)
    );
  });

  it("removes message event listener on destroy", () => {
    const removeEventListenerSpy = jest.spyOn(window, "removeEventListener");
    wrapper.destroy();
    expect(removeEventListenerSpy).toHaveBeenCalledWith(
      "message",
      expect.any(Function)
    );
  });

  it("handles valid Veridas events", async () => {
    const event = {
      origin: "xpressid",
      data: {
        code: "DocumentMounted"
      }
    };
    await wrapper.vm.handleMessage(event);
    expect(window.digitalData).toBeDefined();
  });

  it("ignores events from invalid origins", async () => {
    const event = {
      origin: "invalid-origin",
      data: {
        code: "DocumentMounted"
      }
    };
    await wrapper.vm.handleMessage(event);
    expect(window.digitalData).toEqual({});
  });

  it("backs up and restores digitalData", () => {
    jest.useFakeTimers();
    const originalData = { test: "data" };
    window.digitalData = originalData;

    wrapper.vm.backupDatalayer();
    expect(wrapper.vm.digitalDataBackup).toEqual(originalData);

    wrapper.vm.restoreDatalayer();

    // Fast-forward time to trigger the setTimeout callback
    jest.advanceTimersByTime(500);

    expect(window.digitalData).toEqual(originalData);
    expect(wrapper.vm.digitalDataBackup).toBeNull();
    expect(wrapper.vm.backupTimer).toBeNull();

    jest.useRealTimers();
  });
});
